import { useNavigate } from 'react-router-dom';

type NavigateOptions = { replace?: boolean; state?: unknown };
import { hasAuthToken, ensureDecision, redirectToFallback } from './index';

export function useSmartNavigate() {
  const navigate = useNavigate();
  return async (to: string, options?: NavigateOptions): Promise<void> => {
    // Pre-login (no JWT) → never bounce to legacy; navigate natively in the shell.
    if (!hasAuthToken()) {
      navigate(to, options);
      return;
    }
    // Authenticated: await a decision against a *loaded* toggle set. Right after login the
    // token has just appeared but the poll hasn't fired, so ensureDecision fetches the flags
    // first — otherwise the decision runs against an empty map and hard-bounces to legacy
    // (which then bounces back once it loads the flags: the double-jump).
    const verdict = await ensureDecision(to);
    if (verdict === 'shell') {
      navigate(to, options);
    } else {
      const search = to.includes('?') ? '' : window.location.search;
      const hash   = to.includes('#') ? '' : window.location.hash;
      // Loop guard: if redirecting would oscillate, stay and client-navigate instead.
      if (!redirectToFallback(to, search, hash)) navigate(to, options);
    }
  };
}
